<template>
  <div>
    <b-link
      :href="gridItem.userCanDownload 
        ? `${baseUrl}api/CommonFile/Download?filename=${gridItem.fileName
        }&filePath=${gridItem.filePath}`
         : '#'"
      target="_blank"
    >
      <i
       v-if="gridItem.userCanDownload == true"
        class="grid-commands-icon-search fa fa-file fa-fw mr-2"
        :class="gridItem.userCanDownload !== true ? 'disabled' : ''"
      />
    </b-link>
    <b-link
      :href="gridItem.userCanView 
         ? `${baseUrl}api/CommonFile/View?filename=${gridItem.fileName
         }&filePath=${gridItem.filePath}`
         : '#'"
      target="_blank"
    >
      <i
       v-if="gridItem.userCanView == true"
        class="grid-commands-icon-search fa fa-search fa-fw mr-2"
        :class="gridItem.userCanView !== true ? 'disabled' : ''"
      />
    </b-link>
  </div>
</template>

<script>
import { apiBaseUrl } from '@/resources/myApi';

export default {
  props: ['gridItem'],
  name: 'FileAction',
  data() {
    return {
      baseUrl: apiBaseUrl
    };
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>